import styled from 'styled-components';

import DesignSectionCard from '~organisms/DesignSectionCard';

export const Container = styled(DesignSectionCard)({
  minWidth: '250rem',
});

export const Description = styled.p(({ theme }) => ({
  fontSize: theme.typography.size14,
  fontStyle: 'italic',
}));

export const PriceContainer = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',

  width: '100%',

  fontSize: theme.typography.size16,
  color: theme.palette.darkLiver,
}));

export const PriceCell = styled.div(({ theme }) => ({
  marginBlock: '10rem',
  color: theme.palette.erieBlack,
  fontFamily: theme.typography.family.arial,
  fontSize: '14rem',
  fontStyle: 'normal',
}));
